import * as React from "react";
import {IMapDataContext} from "../../interfaces/demo.interfaces";

const MapDataContext = React.createContext(null as IMapDataContext | null);

export default MapDataContext;
